import { ServiceController } from "Util/serviceController";
import { COMPONENT_TYPE } from "Types/componentTypes";

export function registerPvSystemService(pageController, pvSystemState, serviceControllers) {
    serviceControllers.PvSystem = new PvSystemService(pvSystemState, pageController);
}
class PvSystemService extends ServiceController {
    constructor(state, pageController) {
        super(state, pageController);
        this.inverterModelCache = {};
        this.pvModuleModelCache = {};
        this.equipmentModelCache = {};
    }
    getInverterManufacturers() {
        return this.InverterManufacturers || [];
    }
    getPvModuleManufacturers() {
        return this.PvModuleManufacturers || [];
    }
    getEquipmentManufacturers(equipmentType) {
        let manufacturers = this.EquipmentManufacturers || [];
        manufacturers = manufacturers.filter(function (m) {
            return m.EquipmentType === equipmentType;
        });
        return manufacturers;
    }
    async getInverterModels(manufacturerId, showBatteryComponent, inverterListFiltering) {
        if (this.inverterModelCache[manufacturerId] == undefined) {
            this.inverterModelCache[manufacturerId] = {};
        }
        const showBatteryNumber = showBatteryComponent ? 1 : 0;
        if (this.inverterModelCache[manufacturerId][showBatteryNumber] == undefined) {
            this.inverterModelCache[manufacturerId][showBatteryNumber] = {};
        }
        if (this.inverterModelCache[manufacturerId][showBatteryNumber][inverterListFiltering] == undefined) {
            const result = await this.GetInverterModels2({
                programId: this.ProgramId,
                manufacturerId,
                showBatteryComponent,
                inverterListFiltering
            });
            this.inverterModelCache[manufacturerId][showBatteryNumber][inverterListFiltering] = result.Data;
        }
        return this.inverterModelCache[manufacturerId][showBatteryNumber][inverterListFiltering];
    }
    async getPvModuleModels(manufacturerId) {
        if (this.pvModuleModelCache[manufacturerId] == undefined) {
            const result = await this.GetPvModuleModels({
                programId: this.ProgramId,
                manufacturerId
            });
            this.pvModuleModelCache[manufacturerId] = result.Data;
        }
        return this.pvModuleModelCache[manufacturerId];
    }
    async getEquipmentModels(equipmentType, manufacturerName) {
        if (this.equipmentModelCache[equipmentType] == undefined) {
            this.equipmentModelCache[equipmentType] = {};
        }
        if (this.equipmentModelCache[equipmentType][manufacturerName] == undefined) {
            const result = await this.GetEquipmentModels({
                programId: this.ProgramId,
                equipmentType: equipmentType,
                manufacturerName: manufacturerName
            });
            this.equipmentModelCache[equipmentType][manufacturerName] = result.Data;
        }
        return this.equipmentModelCache[equipmentType][manufacturerName];
    }
    getPvModuleModel(modelId) {
        for (const manufacturerId in this.pvModuleModelCache) {
            const found = this.pvModuleModelCache[manufacturerId].find((x) => x.ModelId === modelId);
            if (found) {
                return found;
            }
        }
        return null;
    }
    getInverterModel(modelId) {
        for (const manufacturerId in this.inverterModelCache) {
            for (const inverterListFiltering in this.inverterModelCache[manufacturerId]) {
                const found = this.inverterModelCache[manufacturerId][inverterListFiltering].find(
                    (x) => x.ModelId === modelId
                );
                if (found) {
                    return found;
                }
            }
        }
        return null;
    }
    async getPVModelName(modelId) {
        const result = await this.GetModelName({
            programId: this.ProgramId,
            modelId: modelId
        });
        return result.Data.Name;
    }
    async getEquipmentModelName(modelId) {
        const result = await this.GetEquimentModelName({
            programId: this.ProgramId,
            equipmentType: COMPONENT_TYPE.Battery,
            modelId: modelId
        });
        return result.Data.Name;
    }
    getEquipmentModel(modelId) {
        for (const equipmentType in this.equipmentModelCache) {
            for (const manufacturerId in this.equipmentModelCache[equipmentType]) {
                const found = this.equipmentModelCache[equipmentType][manufacturerId].find(
                    (x) => x.ModelId === modelId
                );
                if (found) {
                    return found;
                }
            }
        }
        return null;
    }
}
